import { Box, Center } from '@chakra-ui/react'
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext'
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel'
import { SupportOptionsBlock } from '@src/components/sco/SupportOptionsBlock'
import { BreakpointContextProvider } from '@src/components/sco/utilities/BreakpointProvider'
import { useActiveContentContext } from '@src/contexts/ActiveContentContext'
import { useUniversalEffect } from '@src/hooks/useUniversalEffect'
import { AccountPage } from '@src/layouts/AccountPageLayout'
import React from 'react'

export { getServerSideProps } from '@src/lib/server-side-rendering'
export default AccountPage(function () {
  const accountContext = useAccountContext()
  const activeContent = useActiveContentContext()

  useUniversalEffect(() => {
    activeContent.setSiteSection('account.support')
  })

  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([
      {
        title: 'Account',
        href: '/account',
      },
      {
        title: 'Support',
        href: '/account/support',
      },
    ])
  }, [])

  return (
    <AccountMainPanel>
      <Center minHeight={'90vh'} padding={'1em'} width={'full'}>
        <Box
          bgColor={'backgroundSecondary'}
          borderRadius={'xl'}
          maxWidth={'900px'}
          padding={'1em'}
          width={'full'}
        >
          <BreakpointContextProvider>
            <SupportOptionsBlock />
          </BreakpointContextProvider>
        </Box>
      </Center>
    </AccountMainPanel>
  )
})
